//#region Styles
import{
    Container, 
    TextContent
} from "./styles";
//#endregion

const CardLinkItem = ({
    title, 
    description, 
    icon, 
    to
}) => {
    return (
        <Container to={to}>
            {icon}
            <TextContent>
                <h4>{title}</h4>
                <p>{description}</p>
            </TextContent>
        </Container>
    );
}

export default CardLinkItem;